// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rf-0";